import { ICreateQuoteDraftRequest, IQuoteDraftResponse } from '../interfaces/heavyDutyMachinery/IQuoteDraft';
import { apiService } from './ApiService';
import { API_ENDPOINTS } from '../constants/apiEndpoints';
import { HTTP_METHODS } from '../constants/httpMethods';

const heavyDutyMachineryBaseUrl = process.env.REACT_APP_HEAVY_DUTY_MACHINERY_API_URL || '';

/**
 * Returned instead of thrown, because "the assistant is not switched on here"
 * is not an error -- it is a perfectly ordinary state of the platform (the
 * model key is optional, see the backend's QuoteDraftsController), and the
 * screen has to answer it by putting the feature away rather than by showing
 * somebody a red message about something they did not do wrong.
 */
export type QuoteDraftOutcome =
  | { ok: true; draft: IQuoteDraftResponse }
  | { ok: false; unavailable: boolean; error?: string };

/** The backend's own 503 when no model is configured for this environment. */
const SERVICE_UNAVAILABLE = 503;

/**
 * Drafts a quote from a job described in words, priced off the caller's own
 * rate card.
 *
 * Read-only as far as the platform is concerned: nothing is saved until the
 * provider proposes the quote themselves (see proposeNewQuoteAmount). Drafting
 * and proposing are two deliberate acts, because a quote is a commercial
 * commitment and nothing should be able to make one on somebody's behalf.
 */
export const createQuoteDraft = async (request: ICreateQuoteDraftRequest): Promise<QuoteDraftOutcome> => {
  const response = await apiService<IQuoteDraftResponse>({
    url: API_ENDPOINTS.HEAVY_DUTY_MACHINERY_QUOTE_DRAFTS,
    method: HTTP_METHODS.POST,
    body: { ...request },
    baseUrl: heavyDutyMachineryBaseUrl,
  });

  if (response.success) return { ok: true, draft: response.data };
  return { ok: false, unavailable: response.status === SERVICE_UNAVAILABLE, error: response.error };
};
